<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	.demo-class .layui-layer-content {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.checkbox_box .layui-form-radio {
		width: 100% !important;
	}
	
	* {
		margin: 0;
		padding: 0;
	}
	
	a,
	input,
	button {
		outline: none;
	}
	
	::-moz-focus-inner {
		border: 0px;
	}
	
	.white {
		background: #fff !important;
	}
	
	.ft_wt {
		font-weight: 600;
	}
	
	.mon_color {
		color: #FF494C;
	}
	
	.align_center {
		text-align: center !important;
	}
	
	.align_right {
		text-align: right !important;
	}
	
	.titles {
		font-size: 30px;
		padding: 40px 0;
		text-align: center;
	}
	
	.covers {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
	}
	
	.museHover:hover {
		border-color: #4876FF !important;
		color: #4876FF !important;
	}
	
	.min_width {
		min-width: max-content;
	}
	
	.blocks {
		display: block;
	}
	
	.txt_white {
		color: #fff;
	}
	
	.pr_20 {
		padding-right: 20px !important;
	}
	
	.rds_50 {
		border-radius: 50%;
	}
	
	.f_row {
		display: flex !important;
		flex-direction: row !important;
	}
	
	.al_itm {
		display: flex;
		align-items: center;
	}
	
	.al_st {
		display: flex;
		align-items: start;
	}
	
	.color_70 {
		color: #707070;
	}
	
	.jc_ct {
		display: flex;
		justify-content: center;
	}
	
	.f_col {
		display: flex;
		flex-direction: column;
	}
	
	.jc_sb {
		display: flex;
		justify-content: space-between;
	}
	
	.jc_sa {
		display: flex;
		justify-content: space-around;
	}
	
	.jc_end {
		display: flex;
		justify-content: flex-end;
	}
	
	.border_b {
		border-bottom: 1px solid #eee;
	}
	
	.px12 {
		font-size: 12px !important;
	}
	
	.px14 {
		font-size: 14px !important;
	}
	
	.px16 {
		font-size: 16px !important;
	}
	
	.px18 {
		font-size: 18px !important;
	}
	
	.px20 {
		font-size: 20px !important;
	}
	
	.px24 {
		font-size: 24px !important;
	}
	
	.px28 {
		font-size: 28px !important;
	}
	
	.px32 {
		font-size: 32px !important;
	}
	
	.px200 {
		font-size: 200px !important;
	}
	
	.pb_50 {
		padding-bottom: 50px;
	}
	
	.color_q {
		color: #707070 !important;
	}
	
	.color_4a {
		color: #4a4a4a !important;
	}
	
	.zt_color {
		background: #4876FF !important;
	}
	
	.zt_txt_color {
		color: #4876FF !important;
	}
	
	.align_center {
		text-align: center;
	}
	
	.relet {
		position: relative;
	}
	
	.pointer {
		cursor: pointer;
	}
	
	.topIcon {
		width: 30px;
		height: 30px;
		display: block;
		margin-right: 10px;
		/* margin: 50px auto; */
	}
	
	.margin_l0 {
		margin-left: 0;
	}
	
	.margin_l10 {
		margin-left: 10px;
	}
	
	.margin_l20 {
		margin-left: 20px;
	}
	
	.margin_b40 {
		margin-bottom: 40px !important;
	}
	
	button {
		border: none;
	}
	
	.d_line {
		text-decoration: underline;
	}
	
	.rgBoxs input {
		width: 100%;
		line-height: 45px;
		height: 45px;
		border-radius: 0px;
		color: rgba(136, 136, 136, 1);
		text-align: left;
		font-family: Microsoft Yahei;
		border: 1px solid rgba(187, 187, 187, 1);
	}
	
	.layui-form-select dl dd.layui-this {
		background: #4876FF;
	}
	
	.layui-form-radio>i:hover,
	.layui-form-radioed>i {
		color: #4876FF;
	}
	
	.layui-form-radio {
		margin: 0;
		width: 30px;
		height: 30px;
	}
	
	.text .layui-form-radio {
		margin: 0;
		width: auto;
		height: 30px;
	}
	
	.layui-form-label {
		width: 90px;
		line-height: normal;
		text-align: left;
		padding: 9px 0px 9px 0;
		/* min-width: max-content; */
	}
	
	.layui-form-item {
		margin-bottom: 22px;
	}
	/* 首页默认样式 */
	
	.layui-laypage a:hover {
		color: #4876FF;
	}
	
	.layui-nav .layui-this:after,
	.layui-nav-bar,
	.layui-nav-tree .layui-nav-itemed:after {
		background: #fff;
	}
	
	.layui-side-scroll {
		background: #393D49;
	}
	
	.layui-layout-admin .layui-side {
		width: 220px;
	}
	
	.layui-body {
		left: 220px;
		bottom: 0 !important;
		background: #F0F0F2;
		/*padding: 15px;*/
	}
	
	.layui-body .layui-header{
		z-index: 1;
	}
	
	.layui-nav-tree {
		/* border-top: 1px solid #eee; */
		margin: 0px;
		width: 220px;
	}
	
	.layui-nav-tree .layui-nav-bar {
		background: #fff;
		/* background: #51576D; */
	}
	
	.layui-nav-tree .layui-nav-child dd.layui-this,
	.layui-nav-tree .layui-nav-child dd.layui-this a,
	.layui-nav-tree .layui-this,
	.layui-nav-tree .layui-this>a,
	.layui-nav-tree .layui-this>a:hover {
		background: #494E62;
	}
	
	.layui-nav-tree .layui-nav-item {
		/* border-bottom: 1px solid #eee; */
	}
	
	.layui-nav-tree .layui-nav-item a {
		line-height: 60px;
		height: 60px;
		font-size: 16px;
	}
	
	.layui-nav-tree .layui-nav-item a i {
		font-size: 18px;
	}
	
	.layui-progress-bar {
		background: #4876FF;
	}
	/* 充值 */
	
	.layui-btn-primary:hover {
		border-color: #4876FF;
	}
	
	.layui-btn-container .layui-btn {
		min-width: 128px;
	}
	
	.layui-input,
	.layui-select,
	.layui-textarea {
		height: 40px;
	}
	
	.layui-laypage {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	
	.layui-laypage .layui-laypage-curr .layui-laypage-em {
		background: #4876FF;
	}
	
	.layui-form-switch {
		margin-top: 0;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue